import { useContext } from 'react';
import { RelatedArticlesContext } from '../contexts';
import { IRelatedArticles } from '../types';

export default function useRelatedArticles(): IRelatedArticles | undefined {
  const relatedArticles = useContext(RelatedArticlesContext);
  return relatedArticles;
}
